/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {CapitalizePipe as ɵa} from './lib/pipes/Capitalize.pipe';